document.addEventListener('DOMContentLoaded', function() {
  const track = document.getElementById('infinityTrack');
  if (!track) return;
  
  const items = Array.from(track.children);
  const isMovementEnabled = track.dataset.enableMovement === 'true';
  
  // Clone items multiple times for seamless infinite scroll
  for (let i = 0; i < 4; i++) {
    items.forEach(item => {
      const clone = item.cloneNode(true);
      track.appendChild(clone);
    });
  }

  // Add pause/resume listeners if movement is enabled
  if (isMovementEnabled) {
    track.addEventListener('mouseenter', () => {
      track.classList.add('paused');
    });
    track.addEventListener('mouseleave', () => {
      track.classList.remove('paused');
    });

    track.addEventListener('focusin', () => {
      track.classList.add('paused');
    });
    track.addEventListener('focusout', () => {
      track.classList.remove('paused');
    });
  } else {
    track.style.animation = 'none';
  }
});
